export const LOADING = "LOADING";
export const USER = "USER";